import { useEffect, useState } from "react";
import Button2 from "../../../Button/Button2"
import { RuleProvider, useRule } from "./RuleReducer";
import ProgressBar from "./ProgressBar";
import { useScrollTrigger } from "@mui/material";

const ChoosePin = ({pins, firmware, smartLocks, navigate, siteType, advanced}) => {

    console.log(pins)

    const [progress, setProgress] = useState(20)

    useEffect(() => {
        //Clear reducer on initialisation
        dispatch({type: "RESET"})
    }, [])

    
    const { state, dispatch } = useRule(RuleProvider);
    const firmwareSplit = firmware.split(".")
    const major = firmwareSplit[0]
    const minor = firmwareSplit[1]
    const revision = firmwareSplit[2]

    const SupportsOutputPulse = () => {
        if (major > 2) {
            return true
        } else if (major == 2){
            if (minor > 1) {
                return true
            } else if (minor == 1 && revision >= 1){
                return true
            }
        }

        return false
    }

    console.log(SupportsOutputPulse())

    const SupportsInputPulse = () => {
        if (major >= 2) {
            return true
        } else if (major == 1 && minor >= 9){
            return true
        }

        return false
    }
    
    const HandlePinSelected = (pin) => {
        console.log(pin)

        const supportsOutputPulse = SupportsOutputPulse()
        const supportsInputPulse = SupportsInputPulse()

        dispatch({type: "SET_SELECTED_PIN", payload: pin})
        dispatch({type: "SET_PIN_NUMBER", payload: pin.Pin})
        dispatch({type: "SET_IS_LOCK", payload: smartLocks.some(lock => parseInt(lock.outputPin) === pin.Pin)})
        dispatch({type: "SET_IS_REGULAR_OUTPUT", payload: smartLocks.every(lock => parseInt(lock.outputPin) !== pin.Pin)})
        dispatch({type: "SET_IS_INPUT", payload: pin.type == "INPUT" || pin.type == "VIRTUAL_INPUT"})
        dispatch({type: "SET_PIN_STATUS_ON", payload: pin.pinStatusOn})
        dispatch({type: "SET_PIN_STATUS_OFF", payload: pin.pinStatusOff})
        dispatch({type: "SET_DEVICE_UUID", payload: pin.DeviceUUID})
        dispatch({type: "SET_SUPPORTS_OUTPUT_PULSE", payload: supportsOutputPulse})
        dispatch({type: "SET_SUPPORTS_INPUT_PULSE", payload: supportsInputPulse})
        dispatch({type: "SET_SITE_TYPE", payload: pin.DeviceType})
        dispatch({type: "SET_PIN_NAME", payload: pin.pinName})
        dispatch({type: "SET_SUPPORTS_ADV_RULES", payload: advanced }) //siteType == "S"
        dispatch({type: "SET_IS_PULSE", payload: pin.type == "PULSE" || pin.type == "VIRTUAL_PULSE"})
        console.log(siteType)

        console.log(state.isLock)
        console.log(pin.type)
        console.log(smartLocks)
        console.log(supportsOutputPulse)

        if (smartLocks.some(lock => parseInt(lock.outputPin) === pin.Pin)){
            console.log("here")
            //is lock, straight to affected pins
            

           if (advanced){
                console.log('here')
                navigate(1)
            } else {
                dispatch({type: "SET_INPUT_TYPE", payload: 2})
            dispatch({type: "SET_INPUT_TYPE_COPY", payload: 2})
            
            if (!supportsOutputPulse){
                dispatch({type: "SET_INPUT_RULE", payload: 0})
            }
               console.log('here')
               navigate(2)
            }
        } else {
            console.log(advanced)
            if (((pin.type == "INPUT" || pin.type == "VIRTUAL_INPUT") && supportsInputPulse) || (supportsOutputPulse) || (advanced)){
                //Is not a lock, but supports new rules or is an input
                console.log("here")
                navigate(1)
            } else if (!supportsOutputPulse && !advanced){
                console.log("here")
                //Is a normal output, and doesnt support new rules
                dispatch({type: "SET_INPUT_TYPE", payload: 1})
                dispatch({type: "SET_INPUT_TYPE_COPY", payload: 1})
                dispatch({type: "SET_INPUT_RULE", payload: 0})
                navigate(2)
            }  
        }

        {/*
            
            "conditions": [
        //     {
        //       "condition_type": "STATE_CHECK", // or "TRIGGER_METHOD"
        //       "pin": 6,
        //       "pin_state": "ANY",
        //       "trigger_event": "PULSE",
        //     //   "actor_type": "ANYONE", // or "SPECIFIC_USER"
        //     //   "actor_identifier": "string",
        //     //   "method_type": "ANY_METHOD",
        //     //   "method_value": "...",
        //       "time_condition": "ANYTIME"
        //     //   "time_at": "string",
        //     //   "time_window_start": "string",
        //     //   "time_window_end": "string",
        //     //   "days_of_week": "string"
        //     }
        //   ],
        // */}

        //for Adv rules only
        const condition = {
            condition_type: "STATE_CHECK",
            pin: pin.Pin,
            pin_state: pin.type == "PULSE" || pin.type == "VIRTUAL_PULSE" ? "PULSE" : pin.pin_state,
            trigger_method: pin.type == "PULSE" || pin.type == "VIRTUAL_PULSE" ? "PULSE" : "LATCH",
            trigger_method_type: "ANY",
            time_condition: "ANYTIME",
            days_of_week: state.days_of_week
        }

        dispatch({
            type: "SET_ADV_RULE_CONDITION",
            payload: [...state.conditions, condition]
        })
    }

    return (
        <div>
            <ProgressBar progress={progress} />
            <h3 style={{ color:"#6e6e6e"}}>Which switch triggers the rule?</h3>
            <br></br>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    {pins.map((pin, index) => {
                        return (
                            <Button2 style={{ minWidth: "300px", minHeight:"40px" }} key={index} onClick={() => HandlePinSelected(pin)}>
                                {pin.pinName}
                            </Button2>
                        )
                    })}
                </ul >
            </div>
        </div>
    )

}

export default ChoosePin;